import styled from 'styled-components'
import { primary, textPrimary } from 'styles/Colors'

export const Container = styled.div`
  position: relative;
  width: 100%;
  padding: 2rem var(--dashboard-padding-x, 2.5rem);
  background: linear-gradient(135deg, rgba(46, 77, 230, 0.85) 0%, rgba(32, 35, 54, 0.9) 100%);
  color: white;
  margin-bottom: 0;
`

export const ProfileSection = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
`

export const ProfilePicture = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid rgba(255, 255, 255, 0.3);
  flex-shrink: 0;
  overflow: hidden;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: rgba(255, 255, 255, 0.6);

    .profile-pic-overlay {
      opacity: 1 !important;
    }
  }

  &:focus {
    outline: 2px solid rgba(255, 255, 255, 0.8);
    outline-offset: 2px;
  }
`

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  flex: 1;
`

export const UserName = styled.h1`
  font-family: coresanscr65;
  font-size: 2.5rem;
  font-weight: bold;
  color: white;
  margin: 0;
  line-height: 1.2;
`

export const UserRole = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-family: coresanscr45;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.9);
`